export function preloadImages(srcs, onEachLoaded) {
  return Promise.all(
    srcs.map(
      (src) =>
        new Promise((resolve) => {
          const img = new Image();
          img.onload = img.onerror = () => {
            if (onEachLoaded) onEachLoaded();
            resolve();
          };
          img.src = src;
        })
    )
  );
}
